const mEditionMapEnrollmentsFamiliesModalAdd = {
  mEditionMapEnrollmentsFamiliesModalAdd: {
    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La acción fue procesada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'AGREGAR',

    inputs: {
      email: {
        label: 'Emails de Integrantes',
        placeholder: 'Escribe aquí un email y presiona enter.',
        tooltip: 'Si el o los alumnos ya pertenecen a la academia serán asignados al equipo, caso contrario sus inscripciones serán habilitadas una vez que confirmen las invitaciones.'
      }
    },

    title: 'Agregar Integrante',

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'Email de nuevo integrante es requerido.',
        invalid: 'Las siguientes casillas de correo no son válidas:',
        others: 'Y otras',
        more: 'casillas...'
      }
    }
  }
}

export default mEditionMapEnrollmentsFamiliesModalAdd
